import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Hint from '~/Common-Objects/UI/Hint/Hint'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import axios from '../../../../data/http/axios'
import helpers from '../../../../Classes/helpers'
import { alterSiteDrawer } from '../../../../data/actions/siteActions'

const options = [
    {
        label: 'Joins the Segment',
        value: '1'
    },
    {
        label: 'Leaves the Segment',
        value: '2'
    }
]

export default function SegmentAutomate({ SegmentId, segmentName }) {
    const site = useSelector((state) => state.siteMaster)
    const history = useHistory()
    const dispatch = useDispatch()
    const [trigger, setTrigger] = useState('')
    const [name, setName] = useState(segmentName + ' Automation')

    const create = async () => {
        const res = await axios.post('/automation', {
            name,
            version: 1,
            status: 'Draft',
            steps: [
                {
                    guid: helpers.createLocalGuid(),
                    type: 'initial',
                    complete: true,
                    parentGuid: 0,
                    stepOptions: {
                        groupId: {
                            value: '-1000',
                            required: true
                        },
                        segmentId: {
                            value: SegmentId,
                            required: true
                        }
                    },
                    triggerType: {
                        value: trigger,
                        required: true
                    },
                    wizardComplete: true
                }
            ],
            options: {
                source: 'Segment Editor'
            }
        })
        history.push('/cp/automation/addnew/' + res.data.Automation.id + '?redirect=/cp/subscribers/segments')
        dispatch(alterSiteDrawer(false, true, 'right', null))
    }

    return (
        <div>
            <div className='quickFlex mar-b10' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <h4>Create an new Automation</h4>
                {site.siteId === 1 && (
                    <Hint
                        href='https://transpond.io/support/automating-your-communications/transpond-automations'
                        iconLeft={
                            <Icons icon='questionCircle' color='#2B2F41' style={{ height: 16, width: 16 }} />
                        }
                    >
                        Learn More
                    </Hint>
                )}
            </div>

            <p className='mar-b25 text-sml'>
                You can start a new automation based on when contacts join or leave this segment. <br />
                <br />
                Then perform lots of actions such as automatically sending the contact to a chain of emails or change
                their status.
            </p>

            <Select
                outerClassName='mar-b25'
                label='Should this trigger when they enter or leave this segment?'
                data={options}
                value={trigger}
                onChange={(e) => setTrigger(e.target.value)}
            />

            {!!trigger && (
                <TextInput
                    label='Give this new Automation a name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    outerClassName='mar-b25'
                />
            )}

            {!!trigger && !!name && (
                <>
                    <WarningHolder className='mar-b25'>
                        This will create the automation and take you to the automation designer so you can setup any
                        actions you want to happen when this automation is triggered
                    </WarningHolder>
                    <Button className='button-primary' onClick={create}>
                        Create Automation
                    </Button>
                </>
            )}
        </div>
    )
}
